<template>
  <div class="form-card__history">
    <div v-for="(item, index) in getEvent" :key="`${index}`" class="form-card__history-item coll coll-6 coll-m-12 m-24">
      <div class="form-card__history-item-top">
        <div class="form-card__title-container">
          <h5 v-if="item.name || item.eventTypeName" class="title title--h5 title--history">{{ item.name || '' }}.</h5>
          <span class="form-card__subtitle">{{ item.eventTypeName }}</span>
        </div>
        <IconComponent class="" @click.prevent.stop="$emit('edit-event', item.id)" name="edit" />
      </div>

      <p v-if="item.eventLastDate" class="form-card__history-date">
        {{ $momentFormat(item.eventLastDate, Constants.DATE_FORMATS.DD_MMMM_YYYY) }}
      </p>
      <p v-if="item.place" class="form-card__history-country">{{ item.place }}</p>
    </div>
    <div v-if="eventsFull.length > 4" class="coll coll-12 m-24 center">
      <ButtonComponent mod="more" @click.prevent.stop="$emit('toggle-events')">
        {{ showFullListEvent ? 'Скрыть' : 'Показать все исторические данные' }}
        <IconComponent class="icon--full-svg" name="plus-mini" />
      </ButtonComponent>
    </div>
  </div>
</template>

<script>
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import IconComponent from '@/common/ui/IconComponent.vue';

  export default {
    name: 'CommissionEventsHistory',
    components: {
      IconComponent,
      ButtonComponent,
    },
    emits: ['edit-event', 'toggle-events'],
    props: {
      eventsFull: {
        type: Array,
        required: true,
        default: () => [],
      },
      getEvent: {
        type: Array,
        required: true,
        default: () => [],
      },
      showFullListEvent: {
        type: Boolean,
        required: true,
        default: false,
      },
    },
    data() {
      return {
        Constants: Constants,
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/theme/default/title.scss';
  @import '@/modules/crossCuttingTask/styles/coll.scss';

  .form-card__history {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding-top: 24px;
    border-top: 1px dashed $grey;

    &-item-top {
      display: flex;
      align-items: start;
      gap: 4px;
    }

    .hidden {
      display: none;
    }

    p {
      font: $fira-12;
      margin-bottom: 4px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    @media (max-width: $laptop) {
      padding-top: 16px;
    }
  }

  .form-card__title-container {
    flex: 1;
  }

  .form-card__subtitle.form-card__subtitle {
    font: $fira-16;
    margin-bottom: 4px;
  }
</style>
